import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EnergySavingsLeafIcon(props: IconProps) {
    return <Icon {...props} iconKey={"energy_savings_leaf"}/>
}
